export default "__VITE_ASSET__ZYBsKaeH__"